(() => {
  const labels = new Map([
    ['CASE STUDY 2.5', 'CASE STUDY 2.5 (COMING SOON)'],
    ['CASE STUDY 2', 'CASE STUDY 2 (COMING SOON)'],
    ['CASE STUDY 1', 'CASE STUDY 1 (COMING SOON)']
  ]);

  const normalise = value => value.replace(/\s+/g, ' ').trim().toUpperCase();

  function updateMenus(root = document.body) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      const key = normalise(node.nodeValue || '');
      const replacement = labels.get(key);
      if (!replacement) return;

      const original = node.nodeValue || '';
      const leading = original.match(/^\s*/)?.[0] || '';
      const trailing = original.match(/\s*$/)?.[0] || '';
      node.nodeValue = leading + replacement + trailing;

      const element = node.parentElement;
      if (!element) return;
      const target = element.closest('a, button, [role="link"], [onclick], [data-href], li') || element;
      target.classList.add('aeliza-case-study-coming-soon');
      target.setAttribute('aria-disabled', 'true');
      if (target.matches('a, button, [role="link"], [onclick], [data-href]')) {
        target.setAttribute('tabindex', '-1');
      }
    });
  }

  let queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      updateMenus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  } else {
    queueUpdate();
  }

  new MutationObserver(queueUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', event => {
    if (event.target.closest('.aeliza-case-study-coming-soon')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();